import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import vins from './vi/translate.json';
import enns from './en/translate.json';

export const defaultNS = 'vins';

export const resources = {
  en: {
    enns
  },
  vi: {
    vins
  }
};

i18next.use(initReactI18next).init({
  lng: 'vi', // if you're using a language detector, do not define the lng option
  debug: true,
  resources,
  defaultNS,
});